module.exports = __webpack_public_path__ + "img/logo-chrome.3e1ab00b.svg";